import Particles, { initParticlesEngine } from "@tsparticles/react";
import { useEffect, useMemo, useState } from "react";
import { loadFull } from "tsparticles";

const ParticlesComponent = (props) => {
  const [init, setInit] = useState(false);

  useEffect(() => {
    initParticlesEngine(async (engine) => {
      await loadFull(engine);
      await engine.addPreset("links");  // Load the "links" preset
    }).then(() => {
      setInit(true);
    });
  }, []);

  const particlesLoaded = (container) => {
    console.log(container);
  };

  const options = useMemo(
    () => ({
      preset: "links",  // Apply the "links" preset
      background: {
        color: {
          value: "#010e2b",  // Set background color
        },
      },
      fpsLimit: 150,
      interactivity: {
        events: {
          onClick: {
            enable: false,
            mode: "repulse",
          },
          onHover: {
            enable: false,
            mode: "grab",
          },
        },
        modes: {
          push: {
            distance: 200,
            duration: 15,
          },
          grab: {
            distance: 150,
          },
        },
      },
      particles: {
        color: {
          value: "#4194cb",  // Particle color
        },
        links: {
          color: "#6abce2",  // Link color
          distance: 150,
          enable: true,
          opacity: 0.5,  // Ensure links are visible
          width: 1,
        },
        move: {
          direction: "none",
          enable: true,
          outModes: {
            default: "bounce",
          },
          random: false,
          speed: 1,  // Speed for visible movement
          straight: false,
        },
        number: {
          density: {
            enable: true,
            area: 800,  // Ensure enough space for particles
          },
          value: 150,  // Set number of particles
        },
        opacity: {
          value: 0.8,  // Make particles visible
        },
        shape: {
          type: "circle",  // Shape of particles
        },
        size: {
          value: { min: 0.5, max: 2 },  // Size range of particles
        },
      },
      detectRetina: true,
    }),
    [],
  );

  return init ? <Particles id={props.id} init={particlesLoaded} options={options} /> : null;
};

export default ParticlesComponent;
